import { PublicPageTemplate } from "./PublicPageTemplate";

const SolutionReprisePage = () => (
  <PublicPageTemplate
    badge="Reprise d'entreprise"
    title="Sécurisez votre"
    highlight="reprise"
    description="Audit IA complet, due diligence automatisée et plan de transformation pour reprendre une entreprise en toute confiance."
  />
);
export default SolutionReprisePage;
